import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import {
    booleanReturnOpSchema,
    numberReturnOpSchema,
    stringArrayReturnOpSchema,
    stringReturnOpSchema,
} from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const multipleChoiceElementSchema = baseElementSchema.extend({
    type: z.literal("multipleChoice"),
    question: z.union([z.string(), stringReturnOpSchema]),
    options: z.union([
        stringArrayReturnOpSchema,
        z.array(z.union([z.string(), stringReturnOpSchema])),

        // Old schema. Don't use this anymore. We can now pass the array of strings directly.
        z.object({
            logicOp: stringArrayReturnOpSchema,
        }),
    ]),
    maximumPicks: z.union([z.number(), numberReturnOpSchema]).optional(),
    fillInTheBlank: z.union([z.boolean(), booleanReturnOpSchema]).optional(),
    fillInTheBlankPlaceholder: z
        .union([z.string(), stringReturnOpSchema])
        .optional(),
});
export const multipleChoiceElementDataSchema = z.object({
    answers: z.array(z.string()),
});
export type MultipleChoiceElement = z.infer<typeof multipleChoiceElementSchema>;
export type MultipleChoiceElementData = z.infer<
    typeof multipleChoiceElementDataSchema
>;
